import React, { useEffect, useState } from "react";
import "../../../src/styles/Components/Notice/NoticeBoard.css";
import { enableRipple } from "@syncfusion/ej2-base";
import { ContractTemplateInfo } from "../../system/types/interface";
import { ContractTemplateApi, ErrorHandler } from "../../system/ApiService";
import { Link, useHistory } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  CustomButtonBlack,
  CustomButtonWhite,
} from "../../styles/Common/CommonComponent";
import {
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  PaginationMargin,
  StyledBody,
  StyledBody2,
  StyledBodyTitle,
  StyledEmptyBody,
  StyledHead,
  StyledHead2,
  StyledHeadTitle,
} from "../../styles/theme";

import AlertModal from "../Common/AlertModal";
import { useUserState } from "../../system/context/UserContext";

function ContractTemplateBoard() {
  const user = useUserState();
  const [data, setData] = useState<ContractTemplateInfo[]>([]);
  let history = useHistory();
  // 버튼
  enableRipple(true);

  // 페이징 처리
  const [totalData, setTotalData] = useState<ContractTemplateInfo[]>([]);
  const [page, setPage] = useState(1);
  const dataLength = Number(totalData.length);
  const [pageRange, setPageRange] = useState(10);
  const lastPage = Math.ceil(dataLength / pageRange);

  // 게시판 정보 불러오기

  useEffect(() => {
    ContractTemplateApi.GetContractTemplateTotalList()
      .then((res) => {
        setTotalData(res.data);
      })
      .catch((error) => {
        let msg = ErrorHandler(error);
        AlertModal("msg", msg);
      });

    ContractTemplateApi.GetContractTemplateList(page, 10)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        let msg = ErrorHandler(error);
        AlertModal("msg", msg);
      });
  }, [page]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  // 검색창
  const [search, setSearch] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);

  function startSearch() {
    setSearchOpen(true);
  }

  function stopSearch() {
    setSearchOpen(false);
  }

  const onChange = (e: { target: { value: React.SetStateAction<string> } }) => {
    setSearch(e.target.value);
  };
  const [type, setType] = React.useState("");
  const filterTotalData = totalData.filter((p) => {
    if (type === "searchContent") {
      return p.contractTemplateContent
        .replace(" ", "")
        .toLocaleLowerCase()
        .includes(search.toLocaleLowerCase().replace(" ", ""));
    } else if (type === "searchWriter") {
      return p.contractTemplateWriter
        .replace(" ", "")
        .toLocaleLowerCase()
        .includes(search.toLocaleLowerCase().replace(" ", ""));
    } else {
      return p.contractTemplateTitle
        .replace(" ", "")
        .toLocaleLowerCase()
        .includes(search.toLocaleLowerCase().replace(" ", ""));
    }
  });
  const handleChangeType = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  return (
    <div className="noticeBoard">
      <div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "10px",
            }}
          >
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">검색</InputLabel>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={type}
                  label="type"
                  onChange={handleChangeType}
                >
                  <MenuItem value={"searchTitle"}>제목</MenuItem>
                  <MenuItem value={"searchContent"}>내용</MenuItem>
                  <MenuItem value={"searchWriter"}>글쓴이</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Paper
              component="form"
              sx={{
                mx: "10px",
                display: "flex",
                alignItems: "center",
                width: 310,
                height: 40,
              }}
            >
              <input style={{ display: "none" }} />
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="검색하실 단어를 입력해주세요."
                value={search}
                onChange={onChange}
              />
              {searchOpen ? (
                <IconButton
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                  onClick={stopSearch}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </Paper>

            <CustomButtonBlack onClick={startSearch}>검색</CustomButtonBlack>
          </div>

          {searchOpen ? (
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledHead align="center">번호</StyledHead>
                      <StyledHeadTitle align="center">제목</StyledHeadTitle>
                      <StyledHead2 align="center">글쓴이</StyledHead2>
                      <StyledHead2 align="center">작성일</StyledHead2>
                      <StyledHead align="center">조회수</StyledHead>
                    </TableRow>
                  </TableHead>

                  {filterTotalData
                    ? filterTotalData.map((board: any) => {
                        return (
                          <TableBody
                            key={board.contractTemplateId}
                            id={board.contractTemplateId}
                          >
                            <TableRow>
                              <StyledBody align="center">
                                {board.contractTemplateId}
                              </StyledBody>
                              <StyledBodyTitle
                                onClick={() => {
                                  history.push({
                                    pathname: `/contractTemplate/detail/${board.contractTemplateId}`,
                                    state: {
                                      displays: board.contractTemplateId,
                                    },
                                  });
                                }}
                              >
                                {board.contractTemplateTitle}
                              </StyledBodyTitle>
                              <StyledBody2 align="center">
                                {board.contractTemplateWriter}
                              </StyledBody2>
                              <StyledBody2 align="center">
                                {board.contractTemplateCreatedAt}
                              </StyledBody2>
                              <StyledBody align="center">
                                {board.contractTemplateViews}
                              </StyledBody>
                            </TableRow>
                          </TableBody>
                        );
                      })
                    : null}
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledHead align="center">번호</StyledHead>
                      <StyledHeadTitle align="center">제목</StyledHeadTitle>
                      <StyledHead2 align="center">글쓴이</StyledHead2>
                      <StyledHead2 align="center">작성일</StyledHead2>
                      <StyledHead align="center">조회수</StyledHead>
                    </TableRow>
                  </TableHead>

                  {data
                    ? data.map((board: any) => {
                        return (
                          <TableBody
                            key={board.contractTemplateId}
                            id={board.contractTemplateId}
                          >
                            <TableRow>
                              <StyledBody align="center">
                                {board.contractTemplateId}
                              </StyledBody>

                              <StyledBodyTitle
                                onClick={() => {
                                  history.push({
                                    pathname: `/contractTemplate/detail/${board.contractTemplateId}`,
                                    state: {
                                      displays: board.contractTemplateId,
                                    },
                                  });
                                }}
                              >
                                {board.contractTemplateTitle}
                              </StyledBodyTitle>
                              <StyledBody2 align="center">
                                {board.contractTemplateWriter}
                              </StyledBody2>
                              <StyledBody2 align="center">
                                {board.contractTemplateCreatedAt}
                              </StyledBody2>
                              <StyledBody align="center">
                                {board.contractTemplateViews}
                              </StyledBody>
                            </TableRow>
                          </TableBody>
                        );
                      })
                    : null}
                  {dataLength === 0 ? (
                    <TableBody>
                      <TableRow>
                        <StyledEmptyBody colSpan={6}>
                          작성된 계약서 양식이 없습니다.
                        </StyledEmptyBody>
                      </TableRow>
                    </TableBody>
                  ) : null}
                </Table>
              </TableContainer>
            </Grid>
          )}
        </div>
        {(user.employeeId === "20220914" ||
          user.employeeId === "20210601" ||
          user.employeeId === "20240901") && (
          <div style={{ textAlign: "right" }}>
            <Link to="/contractTemplate/edit">
              <CustomButtonWhite style={{ marginTop: "10px" }}>
                글쓰기
              </CustomButtonWhite>
            </Link>
          </div>
        )}

        {searchOpen ? (
          ""
        ) : (
          <PaginationMargin>
            {dataLength === 0 ? (
              ""
            ) : (
              <Stack spacing={2} alignItems="center">
                <Pagination
                  count={lastPage}
                  defaultPage={1}
                  page={page}
                  siblingCount={2}
                  boundaryCount={2}
                  onChange={handleChange}
                />
              </Stack>
            )}
          </PaginationMargin>
        )}
      </div>
    </div>
  );
}

export default ContractTemplateBoard;
